export const INTEGRATIONS_STATE = 'apps.settings.integrations';
export const INTEGRATIONS_LIST_STATE = 'apps.settings.integrations.list';
export const INTEGRATIONS_OPEN_STATE = 'apps.settings.integrations.open';
export const CAP_ALERTS_PAGE_STATE = 'apps.alerts.home';
export const CAP_ALERTS_INTEGRATION_ID = 'cap-alerts';

const INTEGRATION_ID_PATTERN = /^[a-z0-9-]+$/i;

export function isCompanyIntegrationId(value: unknown): value is string {
  return typeof value === 'string' && INTEGRATION_ID_PATTERN.test(value);
}

export function companyIntegrationOpenTarget(integrationId: string): {
  state: string;
  params: { integrationId: string };
} {
  return {
    state: INTEGRATIONS_OPEN_STATE,
    params: { integrationId },
  };
}

export interface CapAlertsReturnTarget {
  state: string;
  params: Record<string, unknown>;
}

/**
 * Where the Alerts page sends the user on Cancel: the state they came from,
 * or the integrations list when there is none worth returning to (a direct
 * load, an abstract source, or the page's own entry point).
 */
export function capAlertsReturnTarget(
  from: { name?: string; abstract?: boolean } | undefined,
  fromParams: Record<string, unknown> | undefined,
): CapAlertsReturnTarget {
  const fallback: CapAlertsReturnTarget = {
    state: INTEGRATIONS_LIST_STATE,
    params: {},
  };
  const name = from?.name;

  if (!name || from.abstract || name === CAP_ALERTS_PAGE_STATE) {
    return fallback;
  }

  if (
    companyIntegrationIdFromRouter(name, fromParams ?? {}) ===
    CAP_ALERTS_INTEGRATION_ID
  ) {
    return fallback;
  }

  return { state: name, params: { ...fromParams } };
}

export function companyIntegrationIdFromRouter(
  stateName: string | undefined,
  params: { integrationId?: unknown },
): string | null {
  if (
    stateName === INTEGRATIONS_OPEN_STATE &&
    isCompanyIntegrationId(params.integrationId)
  ) {
    return params.integrationId;
  }

  return null;
}
